/**
 * @desc 重置盘点单
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.inventoryMaster.resetTask.Params, options?: any) {
  return updateResponse(
    http(URL + `/inventoryMaster/resetTask`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
